import React from "react"
import { Link } from "gatsby"

import MainLayout from "../../components/layout"
import SEO from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

import Intro from "../../components/SubPages/IntroSubPages/introSubPages"
import GridView from "../../components/SubPages/GridViewSubPages/gridViewSubPages"
import CurrentSystem from "../../components/SubPages/ServicesPage/ServiceCurrentSystem/serviceCurrentSystem"
import Carousel from "../../components/SubPages/CarouselSubPages/carouselSubPages"

import ownServerImg from "../../images/services/communicationSystems/own server.png"
import vConferenceImg from "../../images/services/communicationSystems/video conferencing.png"
import chatImg from "../../images/services/communicationSystems/chat.png"
import scalebleImg from "../../images/services/communicationSystems/export.png"
import reliableImg from "../../images/services/communicationSystems/reliable.png"
import supportImg from "../../images/services/communicationSystems/support.png"

import backgroundImg from "../../images/services/communicationSystems/background.svg"

import Constants from "../../constants/services.json"

import CarouselImg1 from "../../images/services/communicationSystems/User - services.png"

const carouselData = [
  {
    title: Constants.customComSystems.carouselData.i1.title,
    description: Constants.customComSystems.carouselData.i1.description,
    img: CarouselImg1,
  },
]

const CustomSystemData = [
  {
    title: Constants.customComSystems.CustomSystemArray.i1.title,
    description: Constants.customComSystems.CustomSystemArray.i1.description,
    img: ownServerImg,
  },
  {
    title: Constants.customComSystems.CustomSystemArray.i2.title,
    description: Constants.customComSystems.CustomSystemArray.i2.description,
    img: vConferenceImg,
  },
  {
    title: Constants.customComSystems.CustomSystemArray.i3.title,
    description: Constants.customComSystems.CustomSystemArray.i3.description,
    img: chatImg,
  },
  {
    title: Constants.customComSystems.CustomSystemArray.i4.title,
    description: Constants.customComSystems.CustomSystemArray.i4.description,
    img: scalebleImg,
  },
  {
    title: Constants.customComSystems.CustomSystemArray.i5.title,
    description: Constants.customComSystems.CustomSystemArray.i5.description,
    img: reliableImg,
  },
  {
    title: Constants.customComSystems.CustomSystemArray.i6.title,
    description: Constants.customComSystems.CustomSystemArray.i6.description,
    img: supportImg,
  },
]

const CustomSystem = () => (
  <MainLayout>
    <SEO
      title="Custom Communication Systems"
      description="We build medium and large scale real-time communication systems with webRTC,XmPP and VOIP meetrix custom communication systems secure remote access solutions. The system will be a white labled custom made according to your requirement.The system can be used independently as a platform of it's own.
            organisation communication systems"
      pagePath="/services/custom-communication-system"
      schema={`{
              "@context": "https://meetrix.io/services/custom-communication-system",
              "@type": "WebPage",
              "mainEntity": {
                "@type": "Organization",
                "name": "Meetrix.io",
              }
            }`}
    />
    <Intro
      title={Constants.customComSystems.MainLayout.title}
      description={Constants.customComSystems.MainLayout.description}
      blueTitle={Constants.customComSystems.MainLayout.blueTitle}
      blueLink=""
      // yellowTitle={Constants.customComSystems.MainLayout.yellowTitle}
      yellowLink=""
      background={backgroundImg}
    />
    <GridView
      title={Constants.customComSystems.GridView.title}
      description={Constants.customComSystems.GridView.description}
      data={CustomSystemData}
    />
    <CurrentSystem
      titleMain={Constants.customComSystems.CurrentSystem.titleMain}
      descriptionMain={Constants.customComSystems.CurrentSystem.descriptionMain}
      title1={Constants.customComSystems.CurrentSystem.title1}
      description1={Constants.customComSystems.CurrentSystem.description1}
      title2={Constants.customComSystems.CurrentSystem.title2}
      description2={Constants.customComSystems.CurrentSystem.description2}
      title3={Constants.customComSystems.CurrentSystem.title3}
      description3={Constants.customComSystems.CurrentSystem.description3}
    />
    <Carousel data={carouselData} />
  </MainLayout>
)

export default CustomSystem
